// Top-nav mega menu data: Products | Solutions | Skills Programs | Partner Offerings
// Items route to existing pages where applicable; the rest fall back to /offerings/all (the master catalog)
// so navigation always lands on a real, useful page until dedicated landing pages ship.

import { LayoutGrid, MonitorPlay, Sparkles, Award, GraduationCap, Users, Briefcase, ShieldCheck, Code2, Cloud, Lock, BarChart3, Brain, Layers, FlaskConical, Wrench, Workflow, Smile } from "lucide-react";

export const PRODUCTS_MENU = [
  {
    section: "PLATFORM",
    items: [
      { label: "Enterprise LMS",              to: "/lxp",          icon: LayoutGrid },
      { label: "eLearning",                   to: "/e-learning",   icon: MonitorPlay },
      { label: "Cloud Labs",                  to: "/offerings/all",icon: Cloud },
      { label: "AI Powered Assessments",      to: "/offerings/all",icon: Brain },
      { label: "AI Powered Coding Platform",  to: "/offerings/all",icon: Code2 }
    ]
  }
];

export const SOLUTIONS_MENU = [
  {
    section: "TRAINING",
    items: [
      { label: "Corporate Training",  to: "/solution/corporate-training",  icon: Briefcase },
      { label: "New Hire Training",   to: "/solution/new-hire-training",   icon: Users },
      { label: "Certifications",      to: "/solution/certifications",      icon: Award },
      { label: "Managed L&D",         to: "/solution/managed-ld",          icon: GraduationCap }
    ]
  },
  {
    section: "TALENT",
    items: [
      { label: "Hire-Train-Deploy",      to: "/solution/hire-train-deploy",      icon: Workflow },
      { label: "Proctored Assessments",  to: "/solution/proctored-assessments",  icon: ShieldCheck },
      { label: "Niche Skill Projects",   to: "/solution/niche-skill-projects",   icon: Sparkles }
    ]
  }
];

export const SKILLS_PROGRAMS_MENU = [
  { label: "GenAI",                        to: "/offerings/genai",                     icon: Sparkles },
  { label: "Data, Analytics & AI",         to: "/offerings/data-analytics-ai",         icon: BarChart3 },
  { label: "Cloud & DevOps",               to: "/offerings/cloud-devops",              icon: Cloud },
  { label: "Cybersecurity",                to: "/offerings/cybersecurity",             icon: Lock },
  { label: "Software Engineering",         to: "/offerings/software-engineering",      icon: Code2 },
  { label: "Applications & Platforms",     to: "/offerings/applications-platforms",    icon: Layers },
  { label: "Testing",                      to: "/offerings/testing",                   icon: FlaskConical },
  { label: "Methodologies & Frameworks",   to: "/offerings/methodologies-frameworks",  icon: Wrench },
  { label: "Soft-Skills",                  to: "/offerings/soft-skills",               icon: Smile }
];
